document.addEventListener("DOMContentLoaded", function () {
  const section = document.getElementById("custom_collection-header");
  if (!section) return;

  const container = section.querySelector(".read-more-container");
  const description = section.querySelector(
    ".custom_collection-header-description"
  );
  const button = section.querySelector(".read-more-less");
  if (!container || !description || !button) return;

  button.addEventListener("click", function () {
    const state = container.getAttribute("state");
    const textClosed = description.getAttribute("text-closed");
    const textOpened = description.getAttribute("text-opened");
    const readMoreText = button.getAttribute("read-more-text");
    const readLessText = button.getAttribute("read-less-text");

    if (!readMoreText || !readLessText) return;

    if (state === "closed") {
      button.textContent = readLessText;
      container.setAttribute("state", "opened");
      description.textContent = textOpened;
    } else {
      button.textContent = readMoreText;
      container.setAttribute("state", "closed");
      description.textContent = textClosed;
    }
  });
});
